import { ContentPage, IPageContent } from "../types/Content";
import HomeIcon from "@mui/icons-material/Home";
import ForumIcon from "@mui/icons-material/Forum";
import BallotIcon from "@mui/icons-material/Ballot";
import DateRangeIcon from "@mui/icons-material/DateRange";
import FolderIcon from "@mui/icons-material/Folder";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import GroupIcon from "@mui/icons-material/Group";
import SecurityIcon from "@mui/icons-material/Security";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import LinkIcon from "@mui/icons-material/Link";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BuildIcon from "@mui/icons-material/Build";
import SvgIcon from "@mui/material/SvgIcon";
import { PAGE_ICON_PATHS } from "./pageIcons";
import * as React from "react";
import { routes } from "../Routes";
import { reverse } from "named-urls";

export const getMenuItemIcon = (page: IPageContent) => {
  switch (page.type) {
    case ContentPage.FRONTPAGE:
      return <HomeIcon />;

    case ContentPage.SURVEYS_LIST:
      return <ForumIcon />;

    case ContentPage.INSPECTIONS_LIST:
      return <BallotIcon />;

    case ContentPage.ACTIONPLANS:
      return <DateRangeIcon />;

    case ContentPage.TEXT_PAGE: {
      const icon = page.pageIcon ? PAGE_ICON_PATHS[page.pageIcon] : undefined;
      return icon ? (
        <SvgIcon viewBox={icon.viewBox}>
          <path d={icon.path} />
        </SvgIcon>
      ) : (
        <FolderIcon />
      );
    }

    case ContentPage.CASES_PAGE:
      return <AssignmentLateIcon />;

    case ContentPage.CHEMICALS_PAGE:
      return (
        <i
          className="fas fa-flask"
          style={{ fontSize: "21px", padding: "2px 3px" }}
        />
      );

    case ContentPage.MEETINGS:
      return <GroupIcon />;

    case ContentPage.WHISTLEBLOWER:
      return <SecurityIcon />;

    case ContentPage.PROCESSES:
      return <AccountTreeIcon />;

    case ContentPage.MENU_LINK:
      return <LinkIcon />;

    case ContentPage.CONTACTS:
      return <ContactPhoneIcon />;

    case ContentPage.TASKS:
      return <CheckCircleIcon />;

    case ContentPage.EQUIPMENT_PAGE:
      return <BuildIcon />;
  }

  return <></>;
};

export const pageContent = (page: IPageContent) => {
  switch (page.type) {
    case ContentPage.SURVEYS_LIST:
      return routes.surveyList;

    case ContentPage.INSPECTIONS_LIST:
      return routes.inspectionList;

    case ContentPage.ACTIONPLANS:
      return routes.actionPlanList;

    case ContentPage.TEXT_PAGE:
      return reverse(routes.cmsPage, {
        id: page.id,
      });

    case ContentPage.CASES_PAGE:
      return routes.reportCase;

    case ContentPage.CHEMICALS_PAGE:
      return routes.chemicalsList;

    case ContentPage.MEETINGS:
      return routes.meetingsList;

    case ContentPage.WHISTLEBLOWER:
      return routes.whistleblower;

    case ContentPage.PROCESSES:
      return routes.processList;

    case ContentPage.MENU_LINK:
      return page.linkUrl;

    case ContentPage.CONTACTS:
      return routes.contacts;

    case ContentPage.TASKS:
      return routes.tasks;

    case ContentPage.EQUIPMENT_PAGE:
      return routes.equipmentList;
  }

  return routes.home;
};
